import React, {memo, useContext, useState} from "react";
import ContentBox from "../../../Components/ContentBox/ContentBox";
import {makeStyles} from "@material-ui/core";
import {makeTableStyles} from "../../../Components/Table/tableStyles";
import {baseTableStyles} from "../../../Lib/simplexion-table/baseStyle";
import {updatableCheckBoxStyle} from "../../../Lib/simplexion-table/templates/checkbox-input";
import {inputFieldStyles} from "../../../Lib/simplexion-table/templates/text-input";
import debug from "../../../Lib/debug";
import {customActions} from "../../../Lib/simplexion-table/templates/action-buttons";
import {FilterField} from "../../../Components/Table/FilterField";
import {SimplexionTable} from "../../../Lib/simplexion-table/SimplexionTable";
import {useInventoryItemGroups} from "../../../Api/item-groups";
import LinearProgress from "@material-ui/core/LinearProgress";
import {AuthContext} from "../../../Lib/auth/AuthContext";
import {roles} from "../../../Main/roles";
import Section from "../../../Lib/form/Components/Section/Section";


const useTableStyles = makeStyles(makeTableStyles(baseTableStyles, updatableCheckBoxStyle, inputFieldStyles));

const List = memo((props) => {

    debug("RENDER", "useForm", () => [" -> List_Of_Inventory_Areas", props]);

    const {path, hasAdminRoles} = props;

    const {loadingStatus, data} = useInventoryItemGroups();

    const urlNs = path[0].url + '/';

    const tableClasses = useTableStyles();

    const [state, setState] = useState('');

    const handleFilter = val => setState(val);

    const authContext = useContext(AuthContext);

    const canCreate = hasAdminRoles ? hasAdminRoles : authContext.getIn(['session', 'roles']).some(role => [roles.TASK_ADMIN.toLowerCase()].indexOf(role) !== -1);

    const tableConfig = {
        id: 'inventory-item-groups-table',
        nameSpace: 'inventoryItemGroups',
        stickyHeader: true,
        sortable: true,
        styles: tableClasses,
        columns: [
            {
                accessor: 'id',
            },
            {
                accessor: 'name',
            },
            {
                accessor: 'query',
            },
            {
                accessor: 'action',
                renderer: (...args) => customActions(true, false, urlNs, ...args),
                sortable: true,
            },
        ],
    };

    return (
        <ContentBox path={path} add={canCreate ? (urlNs + "add") : null}>
            <Section>
                <FilterField handler={handleFilter}/>
                {loadingStatus > 0 ? <LinearProgress/> : null}
                <SimplexionTable tableConfig={tableConfig} data={data} loadingStatus={loadingStatus}
                                 filterValue={state}/>
            </Section>
        </ContentBox>
    );
});

export default List;